import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col,Popover,Table,ConfigProvider,theme } from 'antd';

import help from '../../config/help.json';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;


class Top10DeleteWatchlistContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
				pageSize: 10,
			  
		 }
	}

	async componentDidUpdate(prevProps) {
	}



	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const {  userTheme,opensearchTop10DeleteWatchlistContentList } = this.props;
		cc_data = opensearchTop10DeleteWatchlistContentList || [];
		
		
		// takes an array of objects and the name of a property of these objects
		function getGroupByKeys(array, index){
			let temparr = [];
			array.forEach(d => {
				if(d && d[index]){
					if(!temparr.some(f => f.text === d[index])){
						temparr.push({text:d[index], value:d[index]})
					}
				}
			})
			return temparr;
		}
			
		
		// format table data;
		let dataset = [];
		let key =0;
		cc_data.forEach(d => {
			if(d.seriesTitle && d.seriesTitle.buckets){
				d.seriesTitle.buckets.forEach(c => {
					if(c.episodeTitle && c.episodeTitle.buckets){
						c.episodeTitle.buckets.forEach(f => {		
							dataset.push({movieTitle: d.key, seriesTitle: c.key, episodeTitle: f.key, doc_count: f.doc_count, key:key});
							key+=1;
						})
					}
				})
			}
		})

		dataset = dataset.sort((a, b) => b.doc_count - a.doc_count);
		dataset = dataset.slice(0, 10); // only need the first 10 records.
		const columns = [
			{
			  title: 'Movie Title',
			  dataIndex: 'movieTitle',
			  filters: getGroupByKeys(dataset, "movieTitle"),
			  onFilter: (value, record) => record.movieTitle.indexOf(value) === 0,
			  sorter: (a, b) => a.movieTitle.localeCompare(b.movieTitle),
			  
			},
			{
				title: 'Series Title',
				dataIndex: 'seriesTitle',
				filters: getGroupByKeys(dataset, "seriesTitle"),
				onFilter: (value, record) => record.seriesTitle.indexOf(value) === 0,
				sorter: (a, b) => a.seriesTitle.localeCompare(b.seriesTitle),
				
			},
			{
				title: 'Series Episode Title',
				dataIndex: 'episodeTitle',
				filters: getGroupByKeys(dataset, "episodeTitle"),
				onFilter: (value, record) => record.episodeTitle.indexOf(value) === 0,
				sorter: (a, b) => a.episodeTitle.localeCompare(b.episodeTitle),
			},
			{
			  title: 'Count',
			  dataIndex: 'doc_count',
			  sorter: (a, b) => a.doc_count - b.doc_count,
				defaultSortOrder: 'descend',
			  
			}
		  ];
		  
		  
		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ?darkAlgorithm : defaultAlgorithm,
			  }}>
      <Card className="analyticCard">
				<h3 className="title">{`Top 10 Deleted from Watchlist  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10DeleteWatchlistContent').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={dataset} target="_blank" filename={"Top 10 Deleted from Watchlist.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<Table style={{  width: '100%' }} dataSource={dataset} columns={columns} pagination={{pageSize:5}} />
				</Col>
 				</Row>
     </Card>
	 </ConfigProvider>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchTop10DeleteWatchlistContentList: state.recommendation.opensearchTop10DeleteWatchlistContentList,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10DeleteWatchlistContent));
